<template>
  <div class="container-fluid">
    <div v-if="Boolean(participantDlibr.data.data.length)">
      <DlibrsMobile @showLastConnection="showLastConnection" />
      <!-- User Interface controls -->
      <b-row>
        <b-col cols="4" class="mt-3">
          <b-pagination
            pills
            v-model="table.currentPage"
            :total-rows="table.totalRows"
            :per-page="table.perPage"
            class="my-0"
            @change="pageChange"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="container py-5">
        <b-card class="message">
          <div class="text-center">
            <b-icon icon="archive" font-scale="3" animation="fade"></b-icon>
            <h3>
              Il n'y a pas de résultats disponible
            </h3>
          </div>
        </b-card>
      </div>
    </div>
    <LastConnectionModal
      :data="dataLastConnection"
      :title="titleLastConnection"
    />
  </div>
</template>

<script>
/**
 * @file       Student deliberation component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import { mapState } from "vuex";
import DlibrsMobile from "@/modules/deliberations/components/dlibrsMobile.vue";
import LastConnectionModal from "@/modules/deliberations/components/lastConnectionModal.vue";
import { dlibrsMixin } from "@/modules/deliberations/mixins";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "studentDlibrList",
  components: { DlibrsMobile, LastConnectionModal },
  mixins: [dlibrsMixin],

  /**
   * Before route change.
   * 
   * @param  {string}   to     (Unused)
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    store.commit("deliberations/setParticipantDlibrFilters", {
      reset: true,
      fields: {
        user: store.state.auth.profile.data.data.find(u => u).id
      }
    });
    store.dispatch("deliberations/getParticipantDlibr").then(() => next());
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      participantDlibr: state => state.deliberations.participantDlibr
    }),

    /**
     * Pager table.
     *
     * @return     {Object}
     */
    table() {
      return {
        totalRows: this.participantDlibr.data.total,
        currentPage: this.participantDlibr.data.current_page,
        perPage: this.participantDlibr.data.per_page
      };
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Change deliberation participant page.
     *
     * @param      {int}  page     The page number
     */
    pageChange(page) {
      this.$store.commit("deliberations/setParticipantDlibrFilters", {
        fields: { page }
      });
      this.$store.dispatch("deliberations/getParticipantDlibr");
    },

    /**
     * Change deliberation participant.
     *
     * @param      {Object}  select     The select
     */
    onChange(select) {
      this.$store.commit("deliberations/setParticipantDlibrFilters", {
        fields: { ...select }
      });
      this.$store.dispatch("deliberations/getParticipantDlibr");
    }
  }
};
</script>

<style lang="scss" scoped>
.card-header {
  height: 90px;
}
</style>
